import { render, staticRenderFns } from "./StoriesFullScreen.vue?vue&type=template&id=efe7208e&scoped=true&"
import script from "./StoriesFullScreen.vue?vue&type=script&lang=js&"
export * from "./StoriesFullScreen.vue?vue&type=script&lang=js&"
import style0 from "./StoriesFullScreen.vue?vue&type=style&index=0&id=efe7208e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe7208e",
  null
  
)

export default component.exports